import type { CaptchaType } from "./Captcha";

export type CaptchaData = {
    type: CaptchaType;
    response?: string;
    clientKey: string;
};
export default abstract class AbsCaptcha {
    protected abstract ElWrapperId: string;
    protected abstract captchaType: CaptchaType;
    protected abstract clientKey: string;

    abstract init(): Promise<AbsCaptcha>;
    abstract refresh(): void;
    abstract execute(): Promise<unknown>;
    abstract get captchaData(): CaptchaData;
}
